import { Fade } from '@mui/material';

const createMuiMenuStyles = () => ({
    defaultProps: {
        TransitionComponent: Fade,
    },
});

export default createMuiMenuStyles;
